module.exports = flarum.core.compat['tags/components/TagSelectionModal'];